module.exports = __webpack_public_path__ + "static/img/da-gen.a5ad2fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/bg/da-gen.jpg
// module id = K9A8
// module chunks = 4